import React, { Component } from 'react';
import DropZone from './dropzone.jsx';

class WPCTU extends Component {
	render() {
		return (
			<div className="App">
				<DropZone />
			</div>
		);
	}
}

export default WPCTU;
